// HTTP custom Error

export class BaseHttpError extends Error {
  constructor(statusCode = 0, message, response) {
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BaseHttpError);
    }

    this.statusCode = statusCode;
    this.response = response;
  }
}
